import { createSlice } from "@reduxjs/toolkit";

const initialState = { value: {}, status: false };

const setAppIdSlice = createSlice({
    name: "setAppId",
    initialState,
    reducers: {
        setAppIdRedux(state, action) {
            state.value = action.payload;
            state.status = true;
        },
    },
});

export const { setAppIdRedux } = setAppIdSlice.actions;
export default setAppIdSlice.reducer;
